import request from '@/utils/request'

export interface Project {
  tags: number
  devices: number
  views: number
  alarms: number
  users: number
  datalogs: number
  timeStart: Date
  UTCOffset: number
}

export async function GetProject(): Promise<Project> {
  return request.get('/dashboard/design')
}
